export const statePath = 'apiSuccessCount'
